const FETCH_RECORD_REQUEST = 'SCREENS/RAMSSIGNINGVIEW/FETCH_RECORD_REQUEST'
const FETCH_RECORD_SUCCESS = 'SCREENS/RAMSSIGNINGVIEW/FETCH_RECORD_SUCCESS'
const FETCH_RECORD_FAILURE = 'SCREENS/RAMSSIGNINGVIEW/FETCH_RECORD_FAILURE'
const FETCH_PDF_REQUEST = 'SCREENS/RAMSSIGNINGVIEW/FETCH_PDF_REQUEST'
const FETCH_PDF_SUCCESS = 'SCREENS/RAMSSIGNINGVIEW/FETCH_PDF_SUCCESS'
const FETCH_PDF_FAILURE = 'SCREENS/RAMSSIGNINGVIEW/FETCH_PDF_FAILURE'
const SIGN_REQUEST = 'SCREENS/RAMSSIGNINGVIEW/SIGN_REQUEST'
const SIGN_SUCCESS = 'SCREENS/RAMSSIGNINGVIEW/SIGN_SUCCESS'
const SIGN_FAILURE = 'SCREENS/RAMSSIGNINGVIEW/SIGN_FAILURE'
const RESET = 'SCREENS/RAMSSIGNINGVIEW/RESET'

export {
  FETCH_RECORD_REQUEST,
  FETCH_RECORD_SUCCESS,
  FETCH_RECORD_FAILURE,
  FETCH_PDF_REQUEST,
  FETCH_PDF_SUCCESS,
  FETCH_PDF_FAILURE,
  SIGN_REQUEST,
  SIGN_SUCCESS,
  SIGN_FAILURE,
  RESET,
}

const defaultState = {
  record: null,
  loading: false,
  error: null,
  pdfUrl: null,
  pdfLoading: false,
  signing: false,
  signed: false,
}

const ramsSigningView = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_RECORD_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_RECORD_SUCCESS:
      return { ...state, loading: false, record: action.payload }
    case FETCH_RECORD_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case FETCH_PDF_REQUEST:
      return { ...state, pdfLoading: true }
    case FETCH_PDF_SUCCESS:
      return { ...state, pdfLoading: false, pdfUrl: action.payload }
    case FETCH_PDF_FAILURE:
      return { ...state, pdfLoading: false }
    case SIGN_REQUEST:
      return { ...state, signing: true }
    case SIGN_SUCCESS:
      return { ...state, signing: false, signed: true, record: action.payload }
    case SIGN_FAILURE:
      return { ...state, signing: false }
    case RESET:
      return defaultState
    default:
      return state
  }
}

export default ramsSigningView
